/** Seven consecutive UTC calendar days starting from today (YYYY-MM-DD). */
export function nextSevenUtcDayPeriods(from = new Date()): string[] {
  const start = new Date(Date.UTC(from.getUTCFullYear(), from.getUTCMonth(), from.getUTCDate()));
  return Array.from({ length: 7 }, (_, index) => {
    const day = new Date(start);
    day.setUTCDate(start.getUTCDate() + index);
    return day.toISOString().slice(0, 10);
  });
}

/** Stable 7-day strip — calendar days, optionally aligned to tiled periods when available. */
export function resolveOutlookPeriods(availablePeriods: string[]): string[] {
  const calendar = nextSevenUtcDayPeriods();
  if (availablePeriods.length === 0) return calendar;

  const tiled = availablePeriods.slice(0, 7);
  if (tiled.length >= 7) return tiled;

  const merged = [...tiled];
  for (const period of calendar) {
    if (merged.length >= 7) break;
    if (!merged.includes(period)) merged.push(period);
  }
  return merged.slice(0, 7);
}
